function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_12",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_16",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_27",
  x1: 0.5,
  y1: 0.5,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_34",
  x1: 1,
  y1: 0,
  x2: 0,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_36",
  x1: 0,
  y1: 1,
  x2: 0,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_140",
  x1: 0,
  y1: 0.82422,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9db5b5",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#624a4a",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_143",
  x1: 0.80469,
  y1: 1,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9db5b5",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#624a4a",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_163",
  x1: 0.5,
  y1: 0.5,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#c9c9c9",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#363636",
  offset: 1
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 602,
  height: 602,
  id: "canvas_background",
  fill: "#c9c9c9",
  stroke: "null"
}), /*#__PURE__*/React.createElement("g", {
  id: "canvasGrid",
  display: "none",
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_1",
  width: 1600,
  height: 1200,
  strokeWidth: 0,
  fill: "url(#gridpattern)",
  stroke: "null"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_143)",
  strokeWidth: 1.5,
  x: 0.7481,
  y: 0.41013,
  width: 157.98991,
  height: 598.57384,
  id: "svg_5",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_12)",
  strokeWidth: 1.5,
  x: 139.12409,
  y: 140.6522,
  width: 40,
  height: 459.10031,
  id: "svg_9"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_140)",
  strokeWidth: 1.5,
  x: 144.44723,
  y: -0.70803,
  width: 455.19562,
  height: 160.23809,
  id: "svg_4"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_16)",
  strokeWidth: 1.5,
  x: 139.14047,
  y: 139.51365,
  width: 460.90763,
  height: 40,
  id: "svg_14",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 206.48732,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_51",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 206.48732,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_55",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 498.37657,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_57",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_27)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 139.08684,
  y: 141.27992,
  width: 40,
  height: 38.91438,
  id: "svg_24",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 101.16918,
  y: 96.27122,
  width: 55.48417,
  height: 58.11575,
  id: "svg_29",
  transform: "rotate(45 128.9112701416016,125.3291015625) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 352.43195,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_56",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 359.70696,
  y: 135.49684,
  width: 26.00732,
  height: 6.2271,
  id: "svg_110",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 497.99508,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_113",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 505.2701,
  y: 135.49684,
  width: 26.00732,
  height: 6.2271,
  id: "svg_114",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 207.67525,
  y: 122.26566,
  width: 40,
  height: 22.7025,
  id: "svg_116",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 214.95027,
  y: 135.49684,
  width: 26.00732,
  height: 6.2271,
  id: "svg_117",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14378,
  y: 312.90516,
  width: 40,
  height: 22.7025,
  id: "svg_119",
  rx: 8,
  transform: "rotate(-90 136.14376831054696,324.2564086914063) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63359,
  y: 320.86416,
  width: 26.00732,
  height: 6.2271,
  id: "svg_120",
  rx: 100,
  transform: "rotate(-90 140.63725280761727,323.9777221679688) ",
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14402,
  y: 470.32008,
  width: 40,
  height: 22.7025,
  id: "svg_122",
  rx: 8,
  transform: "rotate(-90 136.1440124511719,481.67132568359375) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63383,
  y: 478.27908,
  width: 26.00732,
  height: 6.2271,
  id: "svg_123",
  rx: 100,
  transform: "rotate(-90 140.63749694824222,481.39263916015625) ",
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 1.27603,
  y: 0.50293,
  width: 162.77047,
  height: 106.85112,
  id: "svg_144",
  stroke: "null"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m58.63473,48.92752l-28.56124,28.57148l28.5639,28.56615l10.38933,-10.38916l-18.17961,-18.17699l18.17584,-18.17703l-10.38821,-10.39445l0,0l-0.00001,0zm41.80161,0l-10.38182,10.39183l18.17589,18.17699l-18.17589,18.17477l10.38182,10.3891l28.56771,-28.56877l-28.56771,-28.56393l0,0.00001z",
  id: "svg_154",
  transform: "rotate(-135 79.53877258300781,77.49633026123047) ",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m511.55232,44.62578l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_155",
  transform: "rotate(90 522.5769042968751,59.69230270385746) ",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m356.51258,44.62578l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_164",
  transform: "rotate(90 367.5372009277344,59.69230270385746) ",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m201.47284,44.62578l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_166",
  transform: "rotate(90 212.49752807617188,59.69230270385744) ",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,506.3862l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_153",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,351.34646l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_172",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,188.55474l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_174",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("g", {
  id: "svg_3"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 456.62222,
  y: 460.38075,
  width: 142.99835,
  height: 138.76986,
  id: "svg_7"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_34)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 429.32658,
  y: 460.0151,
  width: 31.70198,
  height: 139.94542,
  id: "svg_33"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_36)",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  x: 460.50659,
  y: 430.38171,
  width: 139.27036,
  height: 30.43518,
  id: "svg_35"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#svg_163)",
  strokeWidth: 1.5,
  x: 428.90945,
  y: 430.26112,
  width: 31.86972,
  height: 30.19364,
  id: "svg_37",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 513.10757,
  y: 453.46026,
  width: 31.70198,
  height: 17.27386,
  id: "svg_58",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 518.48822,
  y: 456.90857,
  width: 20.86029,
  height: 4.99472,
  id: "svg_130",
  rx: 100,
  stroke: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 455.46306,
  y: 527.36552,
  width: 10.30314,
  height: 30.43518,
  id: "svg_59",
  rx: 8,
  stroke: "null"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m515.91245,530.64211l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  id: "svg_157",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90 460.91836547851557,542.9059448242189) ",
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 450.48822,
  y: 540.40857,
  width: 20.86029,
  height: 4.99472,
  id: "svg_2",
  rx: 100,
  stroke: "#333333"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 600 600"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/ES.42c7fecd.svg";
export { SvgComponent as ReactComponent };